let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iSZk4")).then(() => parcelRequire('83P6O'));